import { BodyText, Button, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect, useMemo } from 'react'

import { useStudentEnrollmentValidationContext } from '../context'
import { Steps } from '../enums'
import styles from './steps.module.scss'

export interface EnrollmentStaticStepProps {
  imageSrc: string
  title: string
  bodyText: React.ReactNode
  bodyText2?: React.ReactNode
  action?: {
    label: React.ReactNode
    onClick?: () => void
    nextStep?: Steps
  }
  testId?: string
  onLoadEvent?: {
    name: string
    metadata?: Record<string, unknown>
  }
}

export function EnrollmentStaticStep(props: EnrollmentStaticStepProps) {
  const { action, imageSrc, title, bodyText, bodyText2, testId, onLoadEvent } = props
  const { setCurrentStep, eventData, viewer } = useStudentEnrollmentValidationContext()
  const pid = viewer?.pid.toString() || null

  const metricsData = useMemo(
    () => ({
      ...eventData,
      metadata: {
        ...eventData?.metadata,
        ...onLoadEvent?.metadata,
      },
    }),
    [eventData, onLoadEvent?.metadata]
  )

  useEffect(() => {
    if (onLoadEvent) {
      sendMetrics(onLoadEvent.name, pid, metricsData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLoadEvent?.name, pid])

  return (
    <>
      <Modal.Body className={styles.body} data-testid={testId}>
        <Image alt={title} src={imageSrc} height={140} width={140} className={styles.image} />
        <Heading size="md" className={styles.title}>
          {title}
        </Heading>
        <BodyText size="md" className={styles.text}>
          {bodyText}
        </BodyText>
        {bodyText2 && (
          <BodyText size="md" className={styles.text}>
            {bodyText2}
          </BodyText>
        )}
      </Modal.Body>
      {action && (
        <Modal.Footer>
          <Button
            kind="primary"
            onClick={() => {
              action.onClick?.()
              if (action.nextStep) {
                setCurrentStep(action.nextStep)
              }
            }}
          >
            {action.label}
          </Button>
        </Modal.Footer>
      )}
    </>
  )
}
